export default "__VITE_PUBLIC_ASSET__680a95bc__"